<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">API Management Bulk</h6>
            <div>
              <input type="file"
                class="mr-5 rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                @change="previewFiles($event)" />
              <button
                class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button" @click="onSubmit($event)">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import APIDataService from "@/services/APIDataService";
import { read, utils } from 'xlsx';
import { ref } from "vue";
import ErrorHandler from "@/ErrorHandler"
const rows = ref([]);


export default {
  setup() {
    const appStore = UseAppStore();

    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api-management", "API Management", "/admin/api-management")
    return {
      appStore,
    }
  },
  data() {
    return {
      alertType: '',
      alertMessage: ''
    }
  },
  components: {

  },
  methods: {
    redirectBack() {
      this.$router.replace('/admin/api-management')
    },
    onSubmit(e) {
      console.log(e)
      console.log(rows.value)
      APIDataService.createBulk({ "data": rows.value })
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'API Management successfuly created'

          this.countDownTimer(3, this.redirectBack)
        })
        .catch(e => {
          ErrorHandler(e)
        });
    },
    previewFiles(e) {
      var files = e.target.files, f = files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = read(data, { type: 'array' });
        let sheetName = workbook.SheetNames[0]
        /* DO SOMETHING WITH workbook HERE */
        let worksheet = workbook.Sheets[sheetName];
        rows.value = utils.sheet_to_json(worksheet)
        rows.value = rows.value.map(item => {
          delete item["id"]
          delete item["created_at"]
          delete item["updated_at"]
          item["is_cache_return"] = (item["is_cache_return"] == "false" ? false : true)
          item["is_mock_api"] = (item["is_mock_api"] == "false" ? false : true)
          item["version"] = String(item["version"])
          return item
        })
      };
      reader.readAsArrayBuffer(f);
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    }
  }
};
</script>
